import { useId } from 'react';
import { Label, RadioGroup, RadioGroupItem } from '@shigo-ui/ui';

import { CustomTargetingExtLogicalOperator } from '../../../../../targeting/customTargetingExtModel';

export function LogicalOperatorRadio({
  value,
  onChange,
  ariaLabel,
}: {
  value: CustomTargetingExtLogicalOperator;
  onChange: (value: CustomTargetingExtLogicalOperator) => void;
  ariaLabel: string;
}) {
  const groupId = useId();
  return (
    <RadioGroup
      value={value}
      onValueChange={(next) => {
        onChange(next as CustomTargetingExtLogicalOperator);
      }}
      className="flex flex-wrap items-center gap-4"
      aria-label={ariaLabel}
    >
      {Object.values(CustomTargetingExtLogicalOperator).map((operator) => {
        const itemId = `${groupId}-${operator}`;
        return (
          <div key={operator} className="flex items-center gap-2">
            <RadioGroupItem id={itemId} value={operator} />
            <Label htmlFor={itemId} className="cursor-pointer text-sm font-medium">
              {operator}
            </Label>
          </div>
        );
      })}
    </RadioGroup>
  );
}
